import { useTitle as _useTitle } from '@vueuse/core';
import { TITLE } from '@/configs/app';

export const useTitle = (title: string) => {
    _useTitle(title + ' - ' + TITLE);
};
